import React, { forwardRef, useMemo } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import { FormHelperTextError } from '../SolvDesignSystem';
import { colors } from '~/constants/colors';

const getRandomId = () => uuid();

const StyledLabel = styled(FormControlLabel).withConfig({ componentId: 'sc-iz42qh-0' })`
  & .label {
    color: ${colors.lanaDelGray};
  }
`;

type Size = 'medium' | 'small';

interface CheckBoxFieldInterface {
  error?: any;
  onChange: (args: any) => void;
  size?: Size;
  value: boolean;
  label: any;
}

const CheckBoxField = forwardRef(function CheckBoxField(
  props: CheckBoxFieldInterface,
  ref: React.Ref<HTMLButtonElement>
) {
  const { error, onChange, size = 'small', value, label } = props;

  const id = useMemo(getRandomId, []);

  return (
    <FormControl error={!!error?.message}>
      <StyledLabel
        classes={{
          label: 'label',
        }}
        control={
          <Checkbox
            checked={value}
            id={id}
            name={id}
            onChange={(_, checked) => {
              onChange?.(checked);
            }}
            ref={ref}
            size={size}
          />
        }
        label={label}
      />
      {!!error?.message && <FormHelperTextError errorText={error?.message} />}
    </FormControl>
  );
});

export default CheckBoxField;
